import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
// componets
import CustomCarousel from './CustomCarousel'
import CardNewsSkeleton from './Skeleton'
// query
import { getBlogPosts } from './blog.service'
// styles
import './styles.scss'

export default function CarouselOtherNews({ data }) {
  const { sectionTitle, showRedirectButton, redirectButton } = data
  const [posts, setPosts] = useState([])
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true)

        const [postsData] = await Promise.all([
          getBlogPosts(),
          new Promise((resolve) => setTimeout(resolve, 2000)),
        ])

        setPosts(postsData)
      } catch (error) {
        setError('Error fetching posts')
      } finally {
        setLoading(false)
      }
    }

    fetchPosts()
  }, [])

  return (
    <section className="custom-news w-screen px-14 md:px-15 lg:px-[50px] xl:px-[100px] 2xl:px-[250px] bg-isabelline">
      {sectionTitle && (
        <>
          <div className="custom-news__header">
            <h2 className="custom-news__title">{sectionTitle}</h2>
          </div>

          <div className="custom-news__divider" />
        </>
      )}

      {loading ? (
        <div className="custom-carousel__container">
          {[1, 2, 3].map((item) => (
            <div className="custom-carousel__slide" key={item}>
              <CardNewsSkeleton />
            </div>
          ))}
        </div>
      ) : (
        <CustomCarousel
          posts={posts}
          showRedirectButton={showRedirectButton}
          redirectButton={redirectButton}
        />
      )}

      {error && <p>{error}</p>}
    </section>
  )
}

CarouselOtherNews.propTypes = {
  data: PropTypes.shape({
    sectionTitle: PropTypes.string,
    showRedirectButton: PropTypes.bool,
    redirectButton: PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
      target: PropTypes.string,
    }),
  }),
}
